import { uniq } from 'lodash';

const DEFAULTS = {
    subItems: {},
    all: {},
};

function updateDirectoryItem(state = {}, item) {
    return { ...state, ...item };
}

export default function (state, action) {
    if (!state) {
        state = { ...DEFAULTS };
    }

    let previous = state;
    switch (action.type) {
        case 'SINGLE_EVENT_UPDATE':
            state = {
                ...state,
                all: [...(action.event.buttons || []), ...(action.event.sponsors || [])].reduce(
                    (all, item) => ({
                        ...all,
                        [item.id]: updateDirectoryItem(state.all[item.id], item),
                    }),
                    state.all
                ),
            };
            break;
        case 'UPDATE_EVENT_SINGLE_DIRECTORY_ITEM':
            state = {
                ...state,
                subItems: {
                    ...state.subItems,
                    [action.item.parent_id]: uniq([...(state.subItems[action.item.parent_id] || []), action.item.id]),
                },
                all: {
                    ...state.all,
                    [action.item.id]: updateDirectoryItem(state.all[action.item.id], action.item),
                },
            };
            break;
        case 'UPDATE_EVENT_DIRECTORY_DATA':
            state = {
                ...state,
                subItems: {
                    ...state.subItems,
                    [action.directoryId]: action.items.map((item) => item.id),
                },
                all: action.items.reduce(
                    (all, item) => ({
                        ...all,
                        [item.id]: updateDirectoryItem(state.all[item.id], item),
                    }),
                    state.all
                ),
            };
            break;
        case 'EVENT_EXHIBITORS_LOAD':
            state = {
                ...state,
                all: action.exhibitors.reduce(
                    (all, item) => ({
                        ...all,
                        [item.id]: updateDirectoryItem(state.all[item.id], item),
                    }),
                    state.all
                ),
            };
            break;
    }

    return state;
}
